import { controls } from "../../controls";
  
  const ms901 = {
    label: "Product",
    starting: true,
    url: "ms901",
    pageLabel: "Product",
    pageType: "history",
    
    filter: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Group",
            name: "",
            description: "Enter Product Group"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "individual"
              },
              {
                label: "Deposit",
                value: "Deposit"
              },
              {
                label: "Loan",
                value: "Loan"
              },
              {
                label: "Bank",
                value: "Bank"
              },
              {
                label: "Other",
                value: "other"
              }
            ],
            placeHolder: "Product Group",
            name: "ProductGroup",
            description: "Enter Product Group"
          },


          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Search",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            name: "search",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Type",
            name: "",
            description: "Enter Product Type"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "individual"
              },
              {
                label: "Internal",
                value: "internal"
              },
              {
                label: "Other",
                value: "other"
              }
            ],
      
            placeHolder: "Product Type",
            name: "ProductType",
            description: "Enter Product Type"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },

          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Name",
            label: "Name",
            name: "",
            description: "Enter Name"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Name",
            name: "Name",
            description: "Enter Name"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "No of Records",
            name: "",
            description: "Enter Records"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            name: "Records",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Active",
            name: "active",
            description: "Active"
          },
    ],
    history: {
      perPage: 10,
      reportHeader: "Employee Information",
      pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
      clickable: true,
      displayColumns: [
        {
          Header: "Sr",
          type: "autoinc",
          accessor: "srno",
          align: 'center',
          width: 30,
        },
        {
          Header: "Branch Code",
          accessor: "branch_code"
        },
        {
          Header: "Employee Code",
          accessor: "employee_code",
        },
        {
          Header: "Full Name",
          accessor: "employee_display",
        }
      ]
    }
}
export default ms901